"use client";

import { useEffect, useState } from "react";
import { Card, Table, Button, Modal, Form, Spinner, ProgressBar, Alert } from "react-bootstrap";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import {
  getCreditRequests,
  createCreditRequest,
  updateCreditRequest,
  updateCreditRequestStatus,
  rejectCreditRequestStatus,
  getUsers,
} from "../../services/store";
import api from "../../services/api";
import AsyncSelect from "react-select/async";
import MoneyInput from "../../components/Custombb/MoneyInput";

const UserSelect = ({ value, onChange }) => {
  const loadOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 2) return []; // حداقل ۲ حرف
    const { data } = await api.get("/store-panel/users", {
      params: { search: inputValue },
    });
    return data.map((u) => ({
      value: u.id,
      label: `${u.name} ${u.family} (${u.mobile || ''}) - ${u.code || ''}`,
      user: u,
    }));
  };

  return (
    <AsyncSelect
      cacheOptions
      loadOptions={loadOptions}
      defaultOptions={false}
      placeholder="نام، شماره یا کد کاربر را وارد کنید..."
      value={value}
      onChange={onChange}
      isClearable
      noOptionsMessage={() => "کاربری یافت نشد"}
      styles={{
        menu: (provided) => ({ ...provided, zIndex: 9999 }),
      }}
    />
  );
};

const StoreCreditRequestsComp = () => {
  const [requests, setRequests] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({
    id: null,
    userId: "",
    userLabel: "",
    mode: "manual", // auto | manual
    totalAmount: "",
    walletAmount: "",
    creditAmount: "",
    description: "",
  });
  const balances = {
    wallet: Number(form.categoryWalletBalance || 0) +
            Number(form.walletBalance || 0),
    /*credit: Number(form.categoryCreditBalance || 0) +
            Number(form.creditBalance || 0),*/
    credit: Number(form.totalCredit || 0),
  };
  const [saving, setSaving] = useState(false);

  const defaultForm = {
    id: null,
    userId: "",
    userLabel: "",
    mode: "manual",
    totalAmount: "",
    walletAmount: "",
    creditAmount: "",
    description: "",
    walletBalance: 0,
    creditBalance: 0,
    categoryWalletBalance: 0,
    categoryCreditBalance: 0,
    totalWallet: 0,
    totalCredit: 0,
  };
  const resetForm = () => setForm(defaultForm);

  const loadData = async () => {
    try {
      const res = await getCreditRequests();
      setRequests(res);
    } catch (err) {
      console.error(err);
      toast.error("خطا در بارگذاری لیست درخواست‌ها");
    } finally {
      setLoading(false);
    }
  };

  const loadUsers = async () => {
    try {
      const res = await getUsers();
      setUsers(res);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadData();
    loadUsers();
  }, []);



  useEffect(() => {
    if (form.mode !== "auto") return;

    const total = Number(form.totalAmount || 0);

    const walletUse = Math.min(total, balances.wallet);
    const creditUse = Math.max(0, total - walletUse);

    setForm((prev) => ({
      ...prev,
      walletAmount: walletUse,
      creditAmount: creditUse,
    }));
  }, [form.totalAmount, form.mode]);

  useEffect(() => {
    if (form.mode !== "manual") return;

    const total =
      Number(form.walletAmount || 0) +
      Number(form.creditAmount || 0);

    setForm((prev) => ({
      ...prev,
      totalAmount: total,
    }));
  }, [form.walletAmount, form.creditAmount, form.mode]);



  const handleSave = async (e) => {
    e.preventDefault();

    if (!form.userId) return toast.error("کاربر را انتخاب کنید");
    if (!form.walletAmount && !form.creditAmount)
      return toast.error("حداقل یکی از مبالغ باید وارد شود");



    const wallet = Number(form.walletAmount || 0);
    const credit = Number(form.creditAmount || 0);

    if (wallet <= 0 && credit <= 0)
      return toast.error("حداقل یکی از مبالغ باید وارد شود");

    if (wallet > Number(form.totalWallet || 0))
      return toast.error("موجودی کیف پول کافی نیست");

    if (credit > Number(form.totalCredit || 0))
      return toast.error("موجودی اعتبار کافی نیست");



    if (Number(form.walletAmount) > Number(form.totalWallet || 0))
      return toast.error("مبلغ کیف پول بیشتر از موجودی قابل استفاده است");

    if (Number(form.creditAmount) > Number(form.totalCredit || 0))
      return toast.error("مبلغ اعتبار بیشتر از موجودی قابل استفاده است");

    const maxAvailable =
      Number(form.totalWallet || 0) +
      Number(form.totalCredit || 0);

    if (Number(form.totalAmount || 0) > maxAvailable)
      return toast.error("مبلغ درخواست بیشتر از موجودی کل است");



    setSaving(true);
    try {
      if (editing) {
        await updateCreditRequest(form.id, form);
        toast.success("درخواست با موفقیت ویرایش شد");
      } else {
        await createCreditRequest(form);
        toast.success("درخواست با موفقیت ثبت شد");
      }
      setShowModal(false);
      //setForm({ id: null, userId: "", walletAmount: "", creditAmount: "", description: "" });
      resetForm();
      loadData();
    } catch (err) {
      console.error(err);
      toast.error("خطا در ثبت درخواست");
    } finally {
      setSaving(false);
      setEditing(false);
    }
  };

  const handleEdit = (req) => {
    setEditing(true);

    const u = req.user || {};

    /*
    setForm({
      id: req.id,
      userId: req.user?.id || "",
      walletAmount: req.walletAmount,
      creditAmount: req.creditAmount,
      description: req.description || "",
    });
    */

    setForm({
      id: req.id,
      userId: u.id || "",
      userLabel: `${u.name || ""} ${u.family || ""} (${u.mobile || ""}) - ${u.code || ""}`,

      walletAmount: req.walletAmount || "",
      creditAmount: req.creditAmount || "",
      description: req.description || "",

      walletBalance: u.walletBalance || 0,
      creditBalance: u.creditBalance || 0,
      categoryWalletBalance: u.categoryWalletBalance || 0,
      categoryCreditBalance: u.categoryCreditBalance || 0,
      totalWallet: u.totalWallet || 0,
      totalCredit: u.totalCredit || 0,
    });

    setShowModal(true);
  };

  const handleVerify = async (req) => {
    const { value: code } = await Swal.fire({
      title: "کد تأیید را وارد کنید",
      input: "text",
      inputLabel: "کد ۶ رقمی تأیید",
      inputPlaceholder: "کد تأیید",
      inputAttributes: { maxlength: 6 },
      showCancelButton: true,
      confirmButtonText: "تأیید",
      cancelButtonText: "انصراف",
    });

    if (!code) return;

    try {
      await updateCreditRequestStatus(req.id, { code });
      toast.success("درخواست با موفقیت تأیید شد");
      loadData();
    } catch (err) {
      console.error(err);
      toast.error("کد تأیید نادرست است");
      loadData();
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
        <p>در حال بارگذاری اطلاعات...</p>
      </div>
    );
  }



  // پول از کجا مصرف می‌شود
  const autoDistribute = (amount, categoryBalance, generalBalance) => {
    const total = categoryBalance + generalBalance;
    const safeAmount = Math.min(amount, total);

    const fromCategory = Math.min(safeAmount, categoryBalance);
    const fromGeneral = safeAmount - fromCategory;

    return {
      safeAmount,
      fromCategory,
      fromGeneral,
      remainCategory: categoryBalance - fromCategory,
      remainGeneral: generalBalance - fromGeneral,
      remainTotal: total - safeAmount,
      percent: total ? (safeAmount / total) * 100 : 0,
    };
  };

  const wallet =
    form.mode === "auto"
      ? autoDistribute(
          Number(form.totalAmount || 0),
          Number(form.categoryWalletBalance || 0),
          Number(form.walletBalance || 0)
        )
      : null;

  const credit =
    form.mode === "auto"
      ? autoDistribute(
          Number(form.totalAmount || 0),
          Number(form.categoryCreditBalance || 0),
          Number(form.creditBalance || 0)
        )
      : null;

  // <BalanceBox.jsx>
  const getVariant = (percent) => {
    if (percent >= 90) return "danger";
    if (percent >= 70) return "warning";
    return "success";
  };

  const WalletProgress = () => {
    const percent = Math.min(
      100,
      (form.walletAmount / balances.wallet) * 100
    );

    return (
      <>
        <div className="d-flex justify-content-between">
          <span>کیف پول</span>
          <span className="text-success">
            {form.walletAmount.toLocaleString()} / {balances.wallet.toLocaleString()}
          </span>
        </div>

        <ProgressBar
          now={percent}
          variant="success"
          animated={form.mode === "auto"}
        />
      </>
    );
  };

  const CreditProgress = () => {
    const percent = Math.min(
      100,
      (form.creditAmount / balances.credit) * 100
    );

    return (
      <>
        <div className="d-flex justify-content-between">
          <span>اعتبار</span>
          <span className="text-warning">
            {form.creditAmount.toLocaleString()} / {balances.credit.toLocaleString()}
          </span>
        </div>

        <ProgressBar
          now={percent}
          variant="warning"
          animated={form.mode === "auto"}
        />
      </>
    );
  };

  const TotalProgress = () => {
    const totalAvailable =
      Number(form.totalWallet || 0) + Number(form.totalCredit || 0);

    const percent = Math.min(
      100,
      (Number(form.totalAmount || 0) / totalAvailable) * 100
    );

    return (
      <Alert variant="light" className="p-3 mb-3">
        <div className="fw-bold mb-2">مصرف کل</div>

        <ProgressBar now={percent} animated variant="primary" />

        <div className="d-flex justify-content-between mt-2 small">
          <span>
            مصرف: {Number(form.totalAmount || 0).toLocaleString()} تومان
          </span>
          <span>
            کل موجودی: {totalAvailable.toLocaleString()} تومان
          </span>
        </div>
      </Alert>
    );
  };

  const BalanceBox = ({ title, data, unit = "تومان" }) => {
    if (!data) return null;

    const variant = getVariant(data.percent);

    return (
      <Alert variant="light" className="p-3 mb-3">
        <div className="fw-bold mb-2">{title}</div>

        <ProgressBar
          animated
          now={data.percent}
          variant={variant}
          style={{ height: "10px" }}
        />

        <div className="d-flex justify-content-between mt-2 small">
          <span>
            مصرف‌شده: {data.safeAmount.toLocaleString()} {unit}
          </span>
          <span className={`text-${variant}`}>
            باقیمانده: {data.remainTotal.toLocaleString()} {unit}
          </span>
        </div>

        <hr />

        <div className="small text-muted">
          <div>
            از فروشگاه: {data.fromCategory.toLocaleString()} {unit}
            {" | "}
            باقیمانده فروشگاه: {data.remainCategory.toLocaleString()}
          </div>
          <div>
            از عمومی: {data.fromGeneral.toLocaleString()} {unit}
            {" | "}
            باقیمانده عمومی: {data.remainGeneral.toLocaleString()}
          </div>
        </div>

        <div className="mt-2 text-info small">
          ترتیب مصرف: ابتدا موجودی فروشگاه سپس عمومی
        </div>
      </Alert>
    );
  };
  // </BalanceBox.jsx>

  

  return (
    <>
      <Card className="border-0 rounded-3 mb-4">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="fw-semibold mb-0">درخواست‌های برداشت اعتبار</h5>
            <Button variant="primary" onClick={() => {
                setEditing(false);
                resetForm();
                setShowModal(true);
              }}>
              <i className="material-symbols-outlined me-1">add</i> درخواست جدید
            </Button>
          </div>

          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>کاربر</th>
                <th>برای فروشگاه</th>
                <th>کیف پول</th>
                <th>اعتبار</th>
                <th>توضیحات</th>
                <th>وضعیت</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {requests.length > 0 ? (
                requests.map((req, i) => (
                  <tr key={req.id}>
                    <td>{i + 1}</td>
                    <td>
                      {req.user?.name || "-"} {req.user?.family || ""}
                      {req.user?.mobile ? `/ موبایل: ${req.user.mobile}` : ""}
                      {req.user?.code ? `/ کد: ${req.user?.code}` : ""}
                    </td>
                    <td>{req.store.name || "-"}</td>
                    <td>{Number(req.walletAmount || 0).toLocaleString()} تومان</td>
                    <td>{Number(req.creditAmount || 0).toLocaleString()} تومان</td>
                    <td>{req.description || "-"}</td>
                    <td>
                      {req.status === "PENDING" && (
                        <span className="badge bg-warning text-dark">در انتظار</span>
                      )}
                      {req.status === "APPROVED" && (
                        <span className="badge bg-success">تایید شده</span>
                      )}
                      {req.status === "REJECTED" && (
                        <span className="badge bg-danger">رد شده</span>
                      )}
                    </td>
                    <td>
                      {req.status === "PENDING" && (
                        <>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="me-2 d-none"
                            onClick={() => handleEdit(req)}
                          >
                            ویرایش
                          </Button>
                          <Button
                            variant="outline-success"
                            size="sm"
                            className="me-2"
                            onClick={() => handleVerify(req)}
                          >
                            تأیید با کد
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={async () => {
                              const { value: comment } = await Swal.fire({
                                title: "لطفاً توضیحی برای رد کردن درخواست وارد کنید",
                                input: "textarea",
                                inputPlaceholder: "توضیح...",
                                showCancelButton: true,
                                confirmButtonText: "رد کردن",
                                cancelButtonText: "انصراف",
                              });

                              if (comment) {
                                try {
                                  await rejectCreditRequestStatus(req.id, { comment: comment??"" });
                                  toast.success("درخواست با موفقیت رد شد");
                                  loadData();
                                } catch (err) {
                                  console.error(err);
                                  toast.error("خطا در رد کردن درخواست");
                                }
                              }
                              else {
                                toast.success("توضیحات را وارد نکردید!");
                              }
                            }}
                          >
                            رد کردن
                          </Button>
                        </>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    هیچ درخواستی ثبت نشده است
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {/* Modal */}
      <Modal show={showModal} onHide={() => {
          setShowModal(false);
          setEditing(false);
          resetForm();
        }} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editing ? "ویرایش درخواست" : "ثبت درخواست جدید"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            <Form.Group className="mb-3">
              <Form.Label>کاربر</Form.Label>
              <UserSelect
                value={form.userId ? { value: form.userId, label: form.userLabel } : null}
                onChange={(selected) => {
                  if (!selected) {
                    setForm({
                      ...defaultForm,
                      userId: "",
                      userLabel: "",
                    });
                    return;
                  }

                  const u = selected.user;
                  
                  setForm({
                    ...form,
                    userId: u.id,
                    userLabel: selected.label,

                    walletBalance: u.walletBalance,
                    creditBalance: u.creditBalance,

                    categoryWalletBalance: u.categoryWalletBalance,
                    categoryCreditBalance: u.categoryCreditBalance,

                    totalWallet: u.totalWallet,
                    totalCredit: u.totalCredit,

                    walletAmount: "",
                    creditAmount: "",
                  });
                }}
              />
            </Form.Group>



            <Form.Group className="mb-3 d-none">
              <Form.Label>نحوه برداشت</Form.Label>

              <div className="mode-toggle">
                <button
                  type="button"
                  className={form.mode === "auto" ? "active" : ""}
                  onClick={() => setForm({ ...form, mode: "auto" })}
                >
                  خودکار
                </button>

                <button
                  type="button"
                  className={form.mode === "manual" ? "active" : ""}
                  onClick={() => setForm({ ...form, mode: "manual" })}
                >
                  دستی
                </button>
              </div>
            </Form.Group>



            {form.mode === "manual" && (
              <>
                <Form.Group className="mb-3">
                  <Form.Label>مصرف از کیف پول</Form.Label>

                  <MoneyInput
                    placeholder="مصرف از کیف پول"
                    value={form.walletAmount}
                    max={balances.wallet}
                    onChange={(v) =>
                      setForm((prev) => ({ ...prev, walletAmount: v }))
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>مصرف از اعتبار</Form.Label>

                  <MoneyInput
                    placeholder="مصرف از اعتبار"
                    value={form.creditAmount}
                    max={balances.credit}
                    onChange={(v) =>
                      setForm((prev) => ({ ...prev, creditAmount: v }))
                    }
                  />
                </Form.Group>

                <Alert variant="light" className="p-3 mb-3">
                  <WalletProgress />
                </Alert>

                <Alert variant="light" className="p-3 mb-3">
                  <CreditProgress />
                </Alert>
              </>
            )}

            {/* ByBehnam - غیر فعال کردن حالت اتوماتیک به درخواست کارفرما */}
            {0 && form.mode === "auto" && (
              <>
                <Form.Group className="mb-3">
                  <Form.Label>مبلغ کل درخواست</Form.Label>
                  
                  <MoneyInput
                    value={form.totalAmount}
                    onChange={(raw) =>
                      setForm({ ...form, totalAmount: raw })
                    }
                    placeholder="مبلغ کل را وارد کنید"
                  />

                  {Number(form.totalAmount) >
                    ( Number(form.totalWallet || 0) + Number(form.totalCredit || 0) ) && (
                    <div className="text-danger small mt-1">
                      مبلغ وارد شده بیشتر از موجودی کل قابل استفاده است
                    </div>
                  )}
                </Form.Group>

                <TotalProgress />

                <Alert variant="info" className="small">
                  <div>ترتیب مصرف: 1️⃣ ابتدا کیف پول فروشگاه 2️⃣ سپس اعتبار عمومی</div>

                  <hr />

                  <div>
                    از کیف پول: {form.walletAmount.toLocaleString()} تومان
                    /
                    از اعتبار: {form.creditAmount.toLocaleString()} تومان
                  </div>
                </Alert>
                
                <Alert variant="light" className="p-3 mb-3">
                  <WalletProgress />
                </Alert>

                <Alert variant="light" className="p-3 mb-3">
                  <CreditProgress />
                </Alert>
              </>
            )}



            <Form.Group className="mb-3">
              <Form.Label>توضیحات</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={form.description}
                onChange={(e) => setForm({ ...form, description: e.target.value })}
              />
            </Form.Group>

            <div className="text-end">
              <Button variant="secondary" onClick={() => {
                  setShowModal(false);
                  setEditing(false);
                  resetForm();
                }} className="me-2">
                انصراف
              </Button>

              {/*}<Button
                variant="primary"
                type="submit"
                disabled={
                  saving ||
                  Number(form.totalAmount) >
                    (Number(form.totalWallet || 0) + Number(form.totalCredit || 0))
                }
              >
                {saving ? "در حال ثبت..." : editing ? "ویرایش" : "ثبت"}
              </Button>{*/}

              <Button variant="primary" type="submit" disabled={!(
                form.userId && !saving &&
                ( Number(form.walletAmount || 0) > 0 || Number(form.creditAmount || 0) > 0 ) &&
                Number(form.walletAmount || 0) <= Number(form.totalWallet || 0) &&
                Number(form.creditAmount || 0) <= Number(form.totalCredit || 0)
              )}>{saving ? "در حال ثبت..." : editing ? "ویرایش" : "ثبت"}</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default StoreCreditRequestsComp;
